"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useEntityUpdateModal = void 0;
var react_1 = __importDefault(require("react"));
var use_modal_1 = require("./use-modal");
var use_entity_definition_1 = require("./use-entity-definition");
var entity_modal_form_route_1 = require("../components/entities/entity-modal-form-route");
var current_user_can_1 = require("../utils/current-user-can");
var use_form_1 = require("./use-form");
var use_entity_1 = require("./use-entity");
var client_1 = require("@apollo/client");
var useEntityUpdateModal = function (entity, args) {
  var modal = (0, use_modal_1.useModal)();
  var form = (0, use_form_1.useForm)();
  var defn = (0, use_entity_definition_1.useEntityDefinition)(entity);
  var detailsEntity = (0, use_entity_1.useEntity)();
  var client = (0, client_1.useApolloClient)();
  // use form context modal if available (need this if menus are going to work in deeply nested forms), otherwise the global modal 
  var showModal = form && form.showModal || modal.show;
  var hideModal = form && form.hideModal || modal.hide;
  var onClick = (0, current_user_can_1.currentUserCanUpdate)(defn.name) ? function (event) {
    event.stopPropagation();
    event.preventDefault();
    showModal(react_1.default.createElement(entity_modal_form_route_1.EntityModalUpdateFormRoute, {
      sourceEntity: args === null || args === void 0 ? void 0 : args.sourceEntity,
      onSubmit: function (entity) {
        if (args && args.onSubmit) {
          args.onSubmit(entity);
        }
        if (detailsEntity) {
          // if there is a master details entity, force it to relaad (we'll optimise this better later) 
          // console.log("EVICTING CACHE OBJECT", client.cache.identify(detailsEntity));
          client.cache.evict({
            id: client.cache.identify(detailsEntity)
          });
          client.cache.gc();
        }
        hideModal();
      },
      onCancel: function () {
        if (args && args.onCancel) {
          args.onCancel(entity);
        }
        hideModal();
      },
      id: entity.id,
      definition: defn
    }), {
      showCloseButton: false
    });
  } : null;
  return __assign(__assign({}, modal), {
    onClick: onClick
  });
};
exports.useEntityUpdateModal = useEntityUpdateModal;